module.exports = __webpack_public_path__ + "static/sport/bg-h5.20c0964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg-h5.png
// module id = dym9
// module chunks = 0